<ng-container *ngIf="profile$ | async as profile">
  <a
    href="{{ url }}"
    class="mat-headline-6"
    >APEX</a
  >
</ng-container>
